module.exports = __webpack_public_path__ + "img/chrome13.5e7c7a01.png";